export default __webpack_public_path__ + "static/media/HDFC-Bank.01be1245.webp";